import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { rem } from "polished"

import { media } from "@sr/common"
import {
  IconFacebook,
  IconInstagram,
  IconTwitter,
  IconLinkedIn,
} from "@sr/gatsby-theme-ui"

export interface AppFooterBottomProps {
  className?: string
}

const FullYear = new Date().getFullYear()

/**
 * Sub footer for social media
 */
const AppFooterBottom = ({ className }: AppFooterBottomProps) => {
  return (
    <AppFooterBottomStyled className={className}>
      <div className="footer__content__mobile">
        <div className="footer__legal">
          <p className="footer__legal__text">
            © {FullYear} SmartRent Technologies, Inc
          </p>
          <Link className="footer__legal__link" to="/privacy/">
            Privacy Policy
          </Link>
          <Link className="footer__legal__link" to="/terms/">
            Terms
          </Link>
          <Link
            className="footer__legal__link"
            to="/responsible-disclosure-policy/"
          >
            Responsible Disclosure Policy
          </Link>
          <Link className="footer__legal__link" to="/sitemap/">
            Sitemap
          </Link>
        </div>
        <div>
          <ul className="social__list__mobile">
            <li className="social__item">
              <a
                className="social__item__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/smartrentdotcom/"
              >
                <IconInstagram color="var(--color-gray600)" />
                <span className="u-hidden-visually">
                  Connect with us on Instagram
                </span>
              </a>
            </li>
            <li className="social__item">
              <a
                className="social__item__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/SmartRentdotcom/"
              >
                <IconTwitter color="var(--color-gray600)" />
                <span className="u-hidden-visually">
                  Connect with us on Twitter
                </span>
              </a>
            </li>
            <li className="social__item">
              <a
                className="social__item__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/smartrentdotcom/"
              >
                <IconFacebook color="var(--color-gray600)" />
                <span className="u-hidden-visually">
                  Connect with us on Facebook
                </span>
              </a>
            </li>
            <li className="social__item">
              <a
                className="social__item__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/smartrentdotcom"
              >
                <IconLinkedIn color="var(--color-gray600)" />
                <span className="u-hidden-visually">
                  Connect with us on LinkedIn
                </span>
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__badge__container">
          <a
            href="https://www.businesswire.com/news/home/20210824005778/en/SmartRent-Completes-Business-Combination-with-Fifth-Wall-Acquisition-Corp.-I"
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="footer__badge__container_nyse"
            >
              <path d="M35.766 54.703c-2.056-.608-2.938-.992-2.938-1.99v-.044c0-.736.724-1.32 1.713-1.32 1.182 0 2.409.563 3.646 1.494l1.602-2.514a7.722 7.722 0 00-5.202-1.93c-2.868 0-4.91 1.824-4.91 4.573v.041c0 2.015 1.86 3.736 4.642 4.64 2.166.698 2.839 1.095 2.839 1.942v.043c0 .887-1.007 1.415-2.035 1.415-1.6 0-2.921-.716-4.181-1.838l-1.617 2.541A8.534 8.534 0 0035.065 64c3.023 0 5.145-2.275 5.145-4.701v-.045c0-2.22-1.612-3.711-4.444-4.551zM46.09 61.14v-3.596h5.944v-2.689H46.09V51.26H53v-2.683h-9.985v15.25H53v-2.685h-6.91zM9.212 48.577v9.606l-6.12-9.606H0v15.25h3.054V53.772l6.405 10.056h2.812V48.576H9.212zm15.756 0l-3.399 5.527-3.406-5.527h-3.68l5.56 8.649v6.602h3.102v-6.665l5.533-8.586h-3.71zM.007 26.661h1.121v8.844h5.585v1.031H.007v-9.875zm9.64 0h1.118v9.875H9.647v-9.875zm4.136 8.434l.697-.816c1.034.93 2.026 1.394 3.4 1.394 1.332 0 2.213-.704 2.213-1.68v-.026c0-.919-.499-1.438-2.577-1.876-2.282-.494-3.332-1.227-3.332-2.852v-.025c0-1.553 1.368-2.694 3.257-2.694a5.18 5.18 0 013.487 1.211l-.652.859c-.919-.746-1.844-1.07-2.861-1.07-1.293 0-2.114.708-2.114 1.594v.03c0 .93.51 1.45 2.691 1.915 2.213.48 3.236 1.284 3.236 2.794v.03c0 1.691-1.421 2.794-3.387 2.794-1.577 0-2.864-.522-4.058-1.582zm12.902-7.406h-3.333V26.66h7.797v1.028H27.81v8.847h-1.125V27.69zm7.325-1.028h7.173v1.016H35.13v3.37h5.415v1.017h-5.416v3.453h6.125v1.02H34.01V26.66zm10.264 0h3.444c3.114 0 5.275 2.13 5.275 4.907v.03c0 2.778-2.16 4.938-5.276 4.938h-3.444v-9.875zm1.123 1.028v7.816h2.32c2.507 0 4.108-1.693 4.108-3.879v-.029c0-2.187-1.601-3.908-4.108-3.908h-2.32zM0 20.38h53v.5H0v-.5zm0 21.914h53v.5H0v-.5zM0 12.061L1.814 9.9c1.256 1.03 2.571 1.686 4.166 1.686 1.256 0 2.013-.496 2.013-1.31v-.04c0-.773-.478-1.17-2.81-1.765C2.372 7.756.558 6.982.558 4.225v-.04C.558 1.665 2.591 0 5.442 0a8.102 8.102 0 015.182 1.766L9.03 4.066c-1.237-.853-2.452-1.369-3.628-1.369-1.176 0-1.794.536-1.794 1.21v.04c0 .912.598 1.21 3.01 1.825 2.83.734 4.425 1.746 4.425 4.166v.04c0 2.757-2.113 4.305-5.122 4.305A8.903 8.903 0 010 12.06zM12.717.198h3.308l3.668 5.872L23.36.198h3.309v13.887h-3.05V5.019l-3.927 5.931h-.08l-3.886-5.872v9.007h-3.01V.198zm16.305 0H35.4c1.774 0 3.15.496 4.066 1.408.777.774 1.195 1.865 1.195 3.175v.04c0 2.24-1.215 3.65-2.99 4.304l3.409 4.96h-3.587l-2.99-4.444h-2.411v4.444h-3.07V.198zM35.2 6.943c1.495 0 2.352-.794 2.352-1.964v-.04c0-1.31-.917-1.984-2.412-1.984h-3.05v3.988h3.11zm10.484-3.928h-4.246V.198H53v2.817h-4.246v11.07h-3.07V3.015z" />
            </svg>
          </a>
        </div>
      </div>

      <div className="footer__content__left__desktop">
        <div className="footer__badge__container">
          <a
            href="https://www.businesswire.com/news/home/20210824005778/en/SmartRent-Completes-Business-Combination-with-Fifth-Wall-Acquisition-Corp.-I"
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="footer__badge__container_nyse"
            >
              <path d="M35.766 54.703c-2.056-.608-2.938-.992-2.938-1.99v-.044c0-.736.724-1.32 1.713-1.32 1.182 0 2.409.563 3.646 1.494l1.602-2.514a7.722 7.722 0 00-5.202-1.93c-2.868 0-4.91 1.824-4.91 4.573v.041c0 2.015 1.86 3.736 4.642 4.64 2.166.698 2.839 1.095 2.839 1.942v.043c0 .887-1.007 1.415-2.035 1.415-1.6 0-2.921-.716-4.181-1.838l-1.617 2.541A8.534 8.534 0 0035.065 64c3.023 0 5.145-2.275 5.145-4.701v-.045c0-2.22-1.612-3.711-4.444-4.551zM46.09 61.14v-3.596h5.944v-2.689H46.09V51.26H53v-2.683h-9.985v15.25H53v-2.685h-6.91zM9.212 48.577v9.606l-6.12-9.606H0v15.25h3.054V53.772l6.405 10.056h2.812V48.576H9.212zm15.756 0l-3.399 5.527-3.406-5.527h-3.68l5.56 8.649v6.602h3.102v-6.665l5.533-8.586h-3.71zM.007 26.661h1.121v8.844h5.585v1.031H.007v-9.875zm9.64 0h1.118v9.875H9.647v-9.875zm4.136 8.434l.697-.816c1.034.93 2.026 1.394 3.4 1.394 1.332 0 2.213-.704 2.213-1.68v-.026c0-.919-.499-1.438-2.577-1.876-2.282-.494-3.332-1.227-3.332-2.852v-.025c0-1.553 1.368-2.694 3.257-2.694a5.18 5.18 0 013.487 1.211l-.652.859c-.919-.746-1.844-1.07-2.861-1.07-1.293 0-2.114.708-2.114 1.594v.03c0 .93.51 1.45 2.691 1.915 2.213.48 3.236 1.284 3.236 2.794v.03c0 1.691-1.421 2.794-3.387 2.794-1.577 0-2.864-.522-4.058-1.582zm12.902-7.406h-3.333V26.66h7.797v1.028H27.81v8.847h-1.125V27.69zm7.325-1.028h7.173v1.016H35.13v3.37h5.415v1.017h-5.416v3.453h6.125v1.02H34.01V26.66zm10.264 0h3.444c3.114 0 5.275 2.13 5.275 4.907v.03c0 2.778-2.16 4.938-5.276 4.938h-3.444v-9.875zm1.123 1.028v7.816h2.32c2.507 0 4.108-1.693 4.108-3.879v-.029c0-2.187-1.601-3.908-4.108-3.908h-2.32zM0 20.38h53v.5H0v-.5zm0 21.914h53v.5H0v-.5zM0 12.061L1.814 9.9c1.256 1.03 2.571 1.686 4.166 1.686 1.256 0 2.013-.496 2.013-1.31v-.04c0-.773-.478-1.17-2.81-1.765C2.372 7.756.558 6.982.558 4.225v-.04C.558 1.665 2.591 0 5.442 0a8.102 8.102 0 015.182 1.766L9.03 4.066c-1.237-.853-2.452-1.369-3.628-1.369-1.176 0-1.794.536-1.794 1.21v.04c0 .912.598 1.21 3.01 1.825 2.83.734 4.425 1.746 4.425 4.166v.04c0 2.757-2.113 4.305-5.122 4.305A8.903 8.903 0 010 12.06zM12.717.198h3.308l3.668 5.872L23.36.198h3.309v13.887h-3.05V5.019l-3.927 5.931h-.08l-3.886-5.872v9.007h-3.01V.198zm16.305 0H35.4c1.774 0 3.15.496 4.066 1.408.777.774 1.195 1.865 1.195 3.175v.04c0 2.24-1.215 3.65-2.99 4.304l3.409 4.96h-3.587l-2.99-4.444h-2.411v4.444h-3.07V.198zM35.2 6.943c1.495 0 2.352-.794 2.352-1.964v-.04c0-1.31-.917-1.984-2.412-1.984h-3.05v3.988h3.11zm10.484-3.928h-4.246V.198H53v2.817h-4.246v11.07h-3.07V3.015z" />
            </svg>
          </a>
        </div>
        <div className="footer__legal">
          <p className="footer__legal__text">
            © {FullYear} SmartRent Technologies, Inc
          </p>
          <Link className="footer__legal__link" to="/privacy/">
            Privacy Policy
          </Link>
          <Link className="footer__legal__link" to="/terms/">
            Terms
          </Link>
          <Link
            className="footer__legal__link"
            to="/responsible-disclosure-policy/"
          >
            Responsible Disclosure Policy
          </Link>
          <Link className="footer__legal__link" to="/sitemap/">
            Sitemap
          </Link>
        </div>
      </div>

      <div>
        <ul className="social__list">
          <li className="social__item">
            <a
              className="social__item__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/smartrentdotcom/"
            >
              <IconInstagram color="var(--color-gray600)" />
              <span className="u-hidden-visually">
                Connect with us on Instagram
              </span>
            </a>
          </li>
          <li className="social__item">
            <a
              className="social__item__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/SmartRentdotcom/"
            >
              <IconTwitter color="var(--color-gray600)" />
              <span className="u-hidden-visually">
                Connect with us on Twitter
              </span>
            </a>
          </li>
          <li className="social__item">
            <a
              className="social__item__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/smartrentdotcom/"
            >
              <IconFacebook color="var(--color-gray600)" />
              <span className="u-hidden-visually">
                Connect with us on Facebook
              </span>
            </a>
          </li>
          <li className="social__item">
            <a
              className="social__item__link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/smartrentdotcom"
            >
              <IconLinkedIn color="var(--color-gray600)" />
              <span className="u-hidden-visually">
                Connect with us on LinkedIn
              </span>
            </a>
          </li>
        </ul>
      </div>
    </AppFooterBottomStyled>
  )
}

export default AppFooterBottom

const AppFooterBottomStyled = styled.div`
  flex: 1 0 100%;
  padding: ${rem(24)} 0 ${rem(24)} 0;
  border-top: 1px var(--color-gray700) solid;
  align-items: center;

  @media ${media.stUp} {
    display: flex;
    justify-content: space-between;
  }

  .footer__content__left__desktop {
    display: none;

    @media ${media.stUp} {
      display: flex;
      flex-direction: column;
      flex-direction: row;
    }
  }

  .footer__content__mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media ${media.stUp} {
      display: none;
    }
  }

  .footer__badge__container {
    display: flex;
    justify-content: center;
    padding: ${rem(24)} 0 0 0;

    @media ${media.stUp} {
      margin-right: ${rem(40)};
      align-items: center;
      padding: 0;
    }
  }

  .footer__badge__container_nyse {
    width: ${rem(53)};
    height: ${rem(64)};
    fill: var(--color-gray200);
  }

  .footer__legal {
    text-align: center;
    padding: 0 ${rem(24)};

    @media ${media.stUp} {
      display: flex;
      flex-basis: auto;
      align-items: center;
      gap: ${rem(24)};
    }
  }

  .footer__legal__text {
    padding: 0 ${rem(16)};
    color: var(--color-gray600);
    font-size: ${rem(14)};

    @media ${media.stUp} {
      padding: 0 ${rem(8)} 0 0;
    }
  }

  .footer__legal__link {
    display: inline-block;
    padding: ${rem(8)} ${rem(16)};
    color: var(--color-gray600);
  }

  .cmp-revoke-consent {
    position: inherit;
    padding: 0 ${rem(16)};
    color: var(--color-gray600);
    font-size: ${rem(14)};

    @media ${media.stUp} {
      padding: 0 ${rem(16)} 0 0;
    }
  }

  .social__list {
    display: none;

    @media ${media.stUp} {
      display: flex;
      justify-content: center;
      gap: ${rem(16)};
    }
  }
  .social__list__mobile {
    display: flex;
    justify-content: center;
    gap: ${rem(16)};
    padding: ${rem(24)} 0 0 0;

    @media ${media.stUp} {
      display: none;
    }
  }

  .social__item__link {
    align-items: center;
    width: ${rem(48)};
  }
`
